@use "../../styles/breakpoint.module.scss" as *;

.columnsContainer {
    // Inlined from composes: grid. The composed class conflicts with the
    // parent .inner subgrid, preventing v2026's display:flex from taking effect.
    display: grid;
    grid-template-columns: repeat(
        var(--labui-grid-column-count),
        minmax(0, 1fr)
    );
    gap: var(--labui-grid-gap);

    @media ($above-tablet) {
        .small {
            grid-column: span 2;
        }

        .regular {
            grid-column: span 3;
        }

        .wide {
            grid-column: span 4;
        }
    }

    @media ($below-tablet) {
        > * {
            grid-column: span 6;
        }
    }

    @media ($below-mobile) {
        > * {
            grid-column: span 4;
        }
    }

    [data-design-version="v2026"] & {
        display: flex;
        justify-content: space-between;
        gap: var(--spacer-24);
        padding-top: var(--spacer-64);

        @media ($below-tablet) {
            flex-wrap: wrap;

            > * {
                flex: 0 0 calc(50% - var(--spacer-12));
            }
        }

        @media ($below-mobile) {
            flex-flow: column nowrap;
            gap: var(--spacer-24);

            > * {
                flex: none;
            }
        }
    }
}

.dl {
    composes: listReset from "../../styles/composable/utility.module.css";
    margin-bottom: var(--spacer-32);

    [data-design-version="v2026"] & {
        display: flex;
        flex-direction: column;
        gap: var(--spacer-16);
        margin-bottom: 0;
    }
}

.link {
    display: block;
    margin-bottom: var(--spacer-8);
    font: var(--font-p-16);
    line-height: 1.3;

    [data-design-version="v2026"] & {
        font: var(--font-nav-16);
        margin-bottom: 0;
    }
}

.columnTitle {
    composes: fontUppercase from "../../styles/composable/typography.module.css";
    font: var(--font-eyebrow);
    padding-bottom: var(--spacer-16);

    [data-design-version="v2026"] & {
        font: var(--font-eyebrow-14);
        color: var(--gray-500);
        padding-bottom: var(--spacer-24);
    }
}
